module.exports = __webpack_public_path__ + "static/media/left-arrow.940d4866.svg";